<template lang="pug">
.sidenav.d-flex.flex-column.align-items-center.py-3
  router-link.transparent-button.px-2(:to='rootPath')
    //- h3.mock-logo UPA
    img(src='@/assets/sidenav/upa-logo.svg' :width='64')

  .sidenav-items.scrollable
    template(v-for='(item, i) in navItems')
      router-link.item(
        :to='item.to'
        :class='selectedIndex === i ? `selected`:``'
      )
        img(:src='item.iconSrc')
        div(
          v-html='item.title'
        )
  .sidenav-items
    button.transparent-button.py-3.px-4(
      @click="$store.dispatch('logout')"
    )
      img(src='@/assets/sidenav/sidenav-button-logout.svg' width='32px')
      //- div ออกจากระบบ
</template>

<script>
/* eslint-disable global-require */
export default {
  props: {
    currentRoute: {
      default: () => ({}),
    },
    navItems: {
      default: () => [],
    },
    rootPath: {
      default: '/',
    },
  },
  computed: {
    selectedIndex() {
      let index = -1;
      for (let i = 0; i < this.navItems.length; i += 1) {
        const item = this.navItems[i];
        if (item.to === this.currentRoute.path) {
          index = i;
        }
      }
      return index;
    },
  },
  methods: {
    isSelected(item) {
      // console.log(item);
      return this.currentRoute.path === item.to;
    },
  },
};
</script>

<style lang="scss">
.sidenav {
  width: $sidenav-width;
  height: 100%;
  background: linear-gradient(#0B478B, #1C87AE);

  // .mock-logo {
  //   color: #fff;
  //   font-size: 32px;
  // }
}
.sidenav-items {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;

  .item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 18px 12px;
    transition: 0.2s;

    // text
    color: rgba(#fff, 0.85);
    text-align: center;
    // font-size: 15px;
    font-size: 14px;
    font-weight: 300;
    letter-spacing: 0.1px;

    img {
      margin-bottom: 12px;
      width: 30px;
      // width: 28px;
    }
    &:hover {
      background: rgba(#000, 0.05);
      // border-radius: 8px;
      text-decoration: none;
      transition: 0s;
    }
    &:focus {
      background: rgba(#000, 0.3);
      // border-radius: 8px;
      text-decoration: none;
      transition: 0s;
    }
    &.selected {
      background: rgba(#000, 0.2)!important;
      text-decoration: none;
      font-weight: 400;
    }
  }
}
</style>
